Counter value: {{ count }}

<br />
<button type="button" (click)="reload()">Reload</button>

<br />
<button type="button" (click)="toVpaPay()">Go to VpaPay</button>
